import React from 'react';
import Footer from '../components/Footer';
import Reveal from '../components/Reveal';
import './LegalPage.css';

const NUM_COLOR = '#059669';

const sections = [
  { id: 't1', num: '1', title: 'Use License', content: (
    <><p>We grant you a limited, non-exclusive, non-transferable, and revocable license to access and use our Services for personal, non-commercial educational purposes. You agree not to:</p>
    <ul className="styled-list">
      <li>Reproduce, duplicate, copy, or sell any portion of our Services</li>
      <li>Attempt to access or search our Services by any means other than our interface</li>
      <li>Harass or cause distress or inconvenience to any person</li>
      <li>Transmit obscene or offensive content or disturb the normal flow of dialogue</li>
      <li>Introduce viruses or malicious code</li>
      <li>Share login credentials or unauthorized access</li>
    </ul></>
  )},
  { id: 't2', num: '2', title: 'Course Content and Intellectual Property', content: (
    <><p>All course materials, videos, texts, images, and other content provided through our Services are proprietary to Ab Meri Baari or licensed content. You may not reproduce, distribute, or transmit any content without explicit permission.</p>
    <p>By uploading or submitting content to our platform, you grant us a non-exclusive, royalty-free license to use, modify, and distribute such content.</p></>
  )},
  { id: 't3', num: '3', title: 'User Accounts', content: (
    <><p>You are responsible for maintaining the confidentiality of your account credentials and password. You agree to:</p>
    <ul className="styled-list">
      <li>Provide accurate and complete information during registration</li>
      <li>Update your information to keep it current</li>
      <li>Notify us immediately of any unauthorized use</li>
      <li>Accept responsibility for all activities under your account</li>
    </ul></>
  )},
  { id: 't4', num: '4', title: 'Payment Terms', content: (
    <><p>If you purchase paid courses or services, you agree to:</p>
    <ul className="styled-list">
      <li>Pay all fees and charges in full and on time</li>
      <li>Provide valid payment information</li>
      <li>Allow recurring billing if applicable</li>
      <li>Acknowledge that all sales are final unless otherwise stated</li>
    </ul></>
  )},
  { id: 't5', num: '5', title: 'Refund Policy', content: (
    <p>Refunds are available within 7 days of purchase if you have not accessed more than 20% of the course content. No refunds are available for courses where substantial content has been accessed.</p>
  )},
  { id: 't6', num: '6', title: 'Limitation of Liability', content: (
    <p>To the fullest extent permitted by law, Ab Meri Baari shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use or inability to use the Services, even if we have been advised of the possibility of such damages.</p>
  )},
  { id: 't7', num: '7', title: 'Disclaimer of Warranties', content: (
    <p>Our Services are provided on an "AS IS" and "AS AVAILABLE" basis. We disclaim all warranties, express or implied, including but not limited to warranties of merchantability, fitness for a particular purpose, and non-infringement.</p>
  )},
  { id: 't8', num: '8', title: 'Termination', content: (
    <><p>We reserve the right to terminate or suspend your account and access to our Services at any time, with or without cause, and with or without notice. Grounds for termination include:</p>
    <ul className="styled-list">
      <li>Violation of these Terms</li>
      <li>Illegal or fraudulent activity</li>
      <li>Harassment or abusive behavior</li>
      <li>Non-payment of fees</li>
    </ul></>
  )},
  { id: 't9', num: '9', title: 'Modifications to Services', content: (
    <p>We reserve the right to modify, suspend, or discontinue our Services at any time. We will attempt to provide notice of significant changes, but cannot guarantee availability or continuity.</p>
  )},
  { id: 't10', num: '10', title: 'Governing Law', content: (
    <p>These Terms are governed by and construed in accordance with the laws of the applicable jurisdiction, and you irrevocably submit to the exclusive jurisdiction of the courts in that location.</p>
  )},
  { id: 't11', num: '11', title: 'Changes to Terms', content: (
    <p>We may update these Terms at any time. Your continued use of the Services following the posting of changes constitutes your acceptance of such changes.</p>
  )},
  { id: 't12', num: '12', title: 'Contact Information', content: (
    <div className="legal-callout legal-callout--info">
      <p><strong>Email:</strong> <a href="mailto:support@abmeribaari.com">support@abmeribaari.com</a></p>
      <p><strong>Address:</strong> Ab Meri Baari, 63 B Saraswati Nagar, Indore, India, PIN: 452001</p>
    </div>
  )},
];

function TermsConditions() {
  return (
    <div>
      <header className="legal-hero legal-hero--terms">
        <Reveal><span className="legal-hero-badge">📄 Terms & Conditions</span></Reveal>
        <Reveal delay={80}><h1>Terms &amp; Conditions</h1></Reveal>
        <Reveal delay={160}><p>Please read these terms carefully before using Ab Meri Baari services.</p></Reveal>
      </header>

      <div className="legal-body">
        <div className="legal-body-inner">
          <aside className="legal-toc">
            <h4>Contents</h4>
            <ul className="legal-toc-list">
              {sections.map((s) => (
                <li key={s.id}><a href={`#${s.id}`}>{s.num}. {s.title}</a></li>
              ))}
            </ul>
          </aside>

          <div className="legal-content">
            <div className="legal-updated">
              <strong>Last Updated:</strong> May 16, 2026
            </div>
            <p className="legal-intro">
              These Terms and Conditions ("Terms") govern your use of the Ab Meri Baari website, mobile applications, and services
              (collectively, the "Services"). By accessing or using our Services, you agree to be bound by these Terms. If you do not
              agree to any part of these Terms, you may not use our Services.
            </p>

            {sections.map((s, i) => (
              <Reveal key={s.id} delay={i * 50}>
                <div className="legal-section" id={s.id}>
                  <div className="legal-section-head">
                    <div className="legal-section-num" style={{ background: NUM_COLOR }}>{s.num}</div>
                    <h2>{s.title}</h2>
                  </div>
                  {s.content}
                </div>
              </Reveal>
            ))}

            <p style={{ fontSize: 'var(--text-xs)', fontStyle: 'italic', color: 'var(--gray-400)', marginTop: '24px' }}>
              By using Ab Meri Baari, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions.
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default TermsConditions;
